export default __webpack_public_path__ + "static/OpenSans-Semibold-fdf56b22f9fbdf2f583fae9bf1f6a2a1.woff";